export type TAssetFormAction = "create" | "edit" | "delete" | "assign";

// Categories are managed on the backend (see ManageCategories) so they can be
// added/renamed/deleted without a code change.
export interface IAssetCategory {
  _id: string;
  name: string;
  prefix: string;
  count?: number;
}

export const ASSET_STATUSES = [
  "Functional",
  "Faulty",
  "Disposed",
  "Missing",
  "Donated",
  "Other",
];

export interface IAssignment {
  name?: string;
  email?: string;
  department?: string;
  phone?: string;
  note?: string;
  assignedAt?: string;
  returnedAt?: string;
}

export interface IAsset {
  _id: string;
  category: string;
  assetNo: string;
  status: string;
  description: string;
  serialNumber?: string;
  supplier?: string;
  purchaseDate?: string;
  totalCost?: number;
  currency?: string;
  notes?: string;
  assignedTo?: IAssignment | null;
  assignmentHistory?: IAssignment[];
  createdAt?: string;
  updatedAt?: string;
}

export interface IAssetForm {
  id?: string;
  category: string;
  assetNo: string;
  status: string;
  description: string;
  serialNumber: string;
  supplier: string;
  purchaseDate: string;
  totalCost: string;
  currency: string;
  notes: string;
}

export interface IAssetPayload {
  category: string;
  assetNo: string;
  status: string;
  description: string;
  serialNumber?: string;
  supplier?: string;
  purchaseDate?: string;
  totalCost?: string | number;
  currency?: string;
  notes?: string;
}

export interface IAssignPayload {
  name: string;
  email?: string;
  department?: string;
  phone?: string;
  note?: string;
}

export interface IBulkImportSummary {
  created: number;
  updated: number;
  skipped: number;
  errors: { assetNo?: string; message: string }[];
}

export interface IAssetState {
  action: TAssetFormAction;
  data: IAssetForm;
}

export const EMPTY_ASSET_FORM: IAssetForm = {
  category: "Laptop",
  assetNo: "",
  status: "Functional",
  description: "",
  serialNumber: "",
  supplier: "",
  purchaseDate: "",
  totalCost: "",
  currency: "UGX",
  notes: "",
};
